module.exports = __webpack_public_path__ + "img/homeparticles.a14330fa.png";